/*
* Created on Jan 14, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/

import React, { useState} from 'react';
import ic_group_d_layer_svg from "../../static/img/content/ic-group-d-layer.svg";
import {useTranslation} from "react-i18next";
// import {useQuery} from "react-query";
// import {useOrganizationApi} from "../../hook/OrganizationAPIHook";


const MainContentSummaryRowGroupComponent = ({organization, goGroups}) => {
    const {t} = useTranslation();
    // const {OrganizationAPI} = useOrganizationApi();
    // const organization_id = organization.organization_id;
    const [groupList, setGroupList] = useState(organization?.groups || []);
    // const [ownerSize, setOwnerSize] = useState(0);
    // const a = OrganizationAPI.get(`organization/${org_id}/group`)

    // const { status, data, error, isFetching } = useQuery(`organization/${organization_id}/group`,
    //     async () => {
    //     const list = await OrganizationAPI.get(`organization/${organization_id}/group`, {limit: 100});
    //     const [owner_size, group_list] = profileGroup(organization, list.result);
    //     setGroupList(group_list);
    //     setOwnerSize(owner_size);
    //     return list;
    // });

    // const profileGroup = (org, groups) => {
    //     let owner = 0
    //     let group_list = [];
    //     for (let u of org.users) {
    //         if (u.is_owner) {
    //             owner++;
    //         }
    //     }
    //
    //     for (let g of groups) {
    //         group_list.push({name: g.name, size: g.users ? g.users.length : 0});
    //     }
    //
    //     return [owner, group_list];
    // }

    return (
        <div className="col-summary col-groups flex-default !w-16">
            <div className="l-section flex-1">
                <div className="section-title">
                    <span className="ic"><img src={ic_group_d_layer_svg} alt=""/></span>
                    <span className="label">{t('@Groups@')}</span>
                </div>
                <div className="total-num">
                    <span>{organization?.groups?.length || '0'}</span>
                    {/*<span>{data && data.result && (data.result.length || '0')}</span>*/}
                    <div className={`comp-dropdown ${organization?.groups?.length <= 0 ? 'hide' : ''}`}>
                        <ul className="comp-dropdown-menu add-scroll overlay-scroll">
                            <li className="section">
                                {/*<div className="section-items selection" onClick={goGroups}>*/}
                                {/*    <div className="item-label">{t('@Owner@')}</div>*/}
                                {/*    <div className="item-val">{ownerSize}</div>*/}
                                {/*</div>*/}
                                {groupList.map((grp) => {
                                    return (
                                        <div className="section-items selection" key={grp.group_id || grp.name} onClick={goGroups}>
                                            <div className="item-label">{grp.name}</div>
                                            <div className="item-val">{grp.member_count ?? grp.users?.length ?? 0}</div>
                                        </div>
                                    )
                                })}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainContentSummaryRowGroupComponent;